import styled from 'styled-components'
import theme from '@/src/config/theme'
import {media} from '@/src/config/theme'

export const Search = styled.div`
  position: relative;
  display: none;
  vertical-align: middle;
  flex: 1;
  line-height: 0;
  justify-content: flex-end;

  [data-input] {
    &::placeholder {
      color: ${theme.colors.white};
    }

    width: 100%;

    //&:not(:focus) {
    //  max-width: 275px;
    //}
  }

  @media ${media.md} {
    display: flex;
  }
`

export const SearchInput = styled.input`
  width: 100%;
  //max-width: 200px;
  position: relative;
  height: 45px;
  line-height: 45px;
  padding: 0 35px 0 10px;
  color: ${theme.colors.textDark};
  background: #ffffff21;
  transition: 1s ease all;

  font-size: 18px;
  border: 1px solid ${theme.colors.foreground}40;
  border-radius: 16px;
    
  -webkit-appearance: none;

  &:focus {
    max-width: 100%;
  }
`

export const SearchButton = styled.input<{$iconUrl: string}>`
  width: 24px;
  height: 24px;
  background: url(${props => props.$iconUrl}) no-repeat 50% 50% / 20px auto;
  border: none;
  font-size: 0;
`
